var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#58A64B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 32.5L33 14L59 32.5L33 52.5L7 32.5Z",
    fill: "#FCD84C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 11,
    fill: "#0054B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34.5C40 27.7 28.5 27.6278 23 28.1278C22.5 29 22 31 22 33C31.6 29.8 40.1667 35.1667 42.5 38.5C44 36 43.5 36.5 44 34.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.3519bc173a4e832e771cf67b6787c79f.svg";
export { ForwardRef as ReactComponent };